import { createSlice } from '@reduxjs/toolkit';

export const liveBidsSlice = createSlice({
  name: 'liveBids',
  initialState: {},
  reducers: {
    updateLiveBids(state, action) {
      return {
        [action.payload.tradeId]: action.payload
      };
    }
  }
});

export default liveBidsSlice.reducer;
